import { canUseWorkspaceApi, ensureWorkspace } from "./classificationWorkspaceApi";

export const RECENT_SEARCH_KEY = "loginhs_recent_searches";
export const PINNED_REVIEW_KEY = "loginhs_pinned_reviews";
export const REVIEW_HISTORY_EVENT = "loginhs:review-history-changed";

function parseStringList(raw, limit) {
  try {
    const parsed = JSON.parse(raw || "[]");
    if (!Array.isArray(parsed)) return [];
    return [...new Set(parsed.map((item) => String(item || "").trim()).filter(Boolean))].slice(
      0,
      limit,
    );
  } catch {
    return [];
  }
}

export function loadRecentReviews(storage = window.localStorage) {
  return parseStringList(storage.getItem(RECENT_SEARCH_KEY), 24);
}

export function loadPinnedReviews(storage = window.localStorage) {
  return parseStringList(storage.getItem(PINNED_REVIEW_KEY), 12);
}

export function saveRecentReview(query, storage = window.localStorage) {
  const value = String(query || "").trim();
  if (!value) return loadRecentReviews(storage);
  const next = [value, ...loadRecentReviews(storage).filter((item) => item !== value)].slice(0, 24);
  storage.setItem(RECENT_SEARCH_KEY, JSON.stringify(next));
  notifyReviewHistoryChanged();
  if (canUseWorkspaceApi()) Promise.resolve(ensureWorkspace(value)).catch(() => {});
  return next;
}

export function removeRecentReview(query, storage = window.localStorage) {
  const value = String(query || "").trim();
  const next = loadRecentReviews(storage).filter((item) => item !== value);
  const pinned = loadPinnedReviews(storage).filter((item) => item !== value);
  storage.setItem(RECENT_SEARCH_KEY, JSON.stringify(next));
  storage.setItem(PINNED_REVIEW_KEY, JSON.stringify(pinned));
  notifyReviewHistoryChanged();
  return next;
}

export function togglePinnedReview(query, storage = window.localStorage) {
  const value = String(query || "").trim();
  if (!value) return loadPinnedReviews(storage);
  const current = loadPinnedReviews(storage);
  const next = current.includes(value)
    ? current.filter((item) => item !== value)
    : [value, ...current].slice(0, 12);
  storage.setItem(PINNED_REVIEW_KEY, JSON.stringify(next));
  notifyReviewHistoryChanged();
  return next;
}

export function notifyReviewHistoryChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(REVIEW_HISTORY_EVENT));
  }
}
